import React from "react";
//#region types
import { TranslationKeys } from "translations";
import { PersonSalaryFormTypes } from "models/formTypes";
import { WintSuperkollAPIModelCustomFilters } from "wint-api-client/dist/types";
import { ACTION_SEPARATOR } from "models/propTypes/menuPropTypes";
//#endregion
//#region components
import { Grid } from "@mui/material";
import { DashboardButtonGroup, FilterButton, PageLayouts } from "components/common";
import { SalarySpecificationsListView, EditSalaryButton } from "components/salary";
import { useEmployeeActions, useEmployeeHelpers } from "components/employee";
import usePersonSalaryReportFilterDefinition from "./forms/useReportFilterDefinition";
import PersonSalaryListView from "./listView";
import { useSalaryService } from "serviceHooks";
import { AddExtraSalaryButton } from "components/salary";
//#endregion
import { LocalizationHelperInstance } from "utils/helpers";

const PersonSalaryReport: React.FC = (props) => {
  const salaryService = useSalaryService();
  const {
    filterFormFields: reportFilterDefinition,
    filterQueryStateHandler,
    apiToReportFilterFormatter,
  } = usePersonSalaryReportFilterDefinition();

  const { employeeSettingsMoreAction, addEmployeeMoreAction } = useEmployeeActions();
  const { canBulkEditSalaries, canAddExtraSalary } = useEmployeeHelpers();

  const getSalaryCreateButtons = () => {
    const buttons: (React.ReactElement | typeof ACTION_SEPARATOR)[] = [];

    if (canAddExtraSalary) {
      buttons.push(<AddExtraSalaryButton />);
    }

    if (canBulkEditSalaries) {
      buttons.push(<EditSalaryButton />);
    }

    if (buttons.length) {
      buttons.push(ACTION_SEPARATOR);
    }

    return buttons;
  };

  return (
    <PageLayouts.DashboardLayout<PersonSalaryFormTypes.Filter>
      entityKey={0}
      title={LocalizationHelperInstance.getFormattedMessage(TranslationKeys.Company.Salaries)}
      topRightButtons={
        <DashboardButtonGroup
          buttons={getSalaryCreateButtons().concat([<FilterButton />])}
          moreActions={[addEmployeeMoreAction, employeeSettingsMoreAction]}
        />
      }
      filterFields={reportFilterDefinition}
      initialFilter={{ yearMonth: { start: new Date(), end: new Date() } }}
      filterQueryStateHandler={filterQueryStateHandler}
      apiToReportFilterFormatter={apiToReportFilterFormatter}
      reportToAPIFilterFormatter={salaryService.personSalaryReportToAPIFilter}
      filterCategory={WintSuperkollAPIModelCustomFilters.FilterCategory.PersonSalary}
    >
      <Grid container item>
        <PersonSalaryListView />
      </Grid>

      <Grid container item>
        <SalarySpecificationsListView useExtendedFilter={false} />
      </Grid>
    </PageLayouts.DashboardLayout>
  );
};

export default PersonSalaryReport;
